import { PageHeader } from "@shared/components/PageHeader";
import {
  IntegrationCardGrid,
  IntegrationCardConfig,
} from "@features/ix/shared/IntegrationCardGrid";
import React from "react";

const SMART_METER_OEM_CARDS: IntegrationCardConfig[] = [
  {
    title: "Neptune",
    subtitle: "AMI / Smart Water Meters",
    description:
      "Neptune R900 / E-CODER cloud — meter readings, alarms and tamper events for water utilities.",
    status: "connect",
    comingSoon: false,
    connectPath: "/smart-meter-oem/neptune/create",
    configurePath: "/smart-meter-oem/neptune/configure",
    detailsPath: "/smart-meter-oem/neptune/view",
  },
];

const SmartMeterOemLanding = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Smart Meter OEM"
        subtitle="Manage OEM integrations for device telemetry, meter lifecycle workflows, and consumption visibility."
      />
      <IntegrationCardGrid cards={SMART_METER_OEM_CARDS} />
    </div>
  );
};

export default SmartMeterOemLanding;
